/**
 * Converts agent XML tags in raw text to markdown (fenced code for execute / stdout).
 * Used for step cards, assistant solution bubble, and streaming preview — no React deps.
 */
/** Emitted on ``RUN_FINISHED.answer_format`` when the agent normalized prose server-side. */
export type AgentAnswerFormat = 'markdown_v1'

export function formatAssistantDisplayMarkdown(raw: string, answerFormat?: AgentAnswerFormat): string {
  if (!raw) return ''
  if (answerFormat === 'markdown_v1') {
    return raw
  }
  return formatAgentXmlToMarkdown(raw)
}

export function formatAgentXmlToMarkdown(raw: string): string {
  if (!raw) return ''
  return raw
    .replace(/<tool\b[^>]*>([\s\S]*?)<\/tool>/gi, (_match, inner: string) => `\n\`\`\`text\n${String(inner).trim()}\n\`\`\`\n`)
    .replace(/<tool\b[^/>]*\/>/gi, '')
    .replace(/<think>|<\/redacted_thinking>/g, '')
    .replace(/<execute>([\s\S]*?)<\/execute>/g, (_match, code: string) => `\n\`\`\`\n${code.trim()}\n\`\`\`\n`)
    .replace(/<execute>/g, '\n```\n')
    .replace(/<\/execute>/g, '\n```\n')
    .replace(/<solution>|<\/solution>/g, '')
    .replace(/<observation>([\s\S]*?)<\/observation>/g, (_match, text: string) => `\n\`\`\`text\n${text.trimEnd()}\n\`\`\`\n`)
    .replace(/<observe>([\s\S]*?)<\/observe>/g, (_match, text: string) => `\n\`\`\`text\n${text.trimEnd()}\n\`\`\`\n`)
    .replace(/<observation>|<\/observation>/g, '')
    .replace(/<observe>|<\/observe>/g, '')
    .trim()
}
